export enum ArticleType {
  RENTAL = "RentalAccommodationArticle",
  SEASONAL = "SeasonalAccommodationArticle",
  ANNUAL = "AnnualAccommodationArticle",
  SALE = "SaleAccommodationArticle"
}

export type ArticleUrlData = {
  __typename: ArticleType;
  id: string;
  slug: string;
}

export const buildSearchUrl = (type: ArticleType) => {
  switch (type) {
    case ArticleType.RENTAL:
      return "/rentals/short/";
    case ArticleType.SEASONAL:
      return "/rentals/seasonally/";
    case ArticleType.ANNUAL:
      return "/rentals/annually/";
    case ArticleType.SALE:
      return "/purchases/";
  }
}

export const buildArticleUrl = (data: ArticleUrlData) =>
  `${buildSearchUrl(data.__typename)}${data.slug}?refId=${data.id}`;
